import handleResponse from "@/assets/handle-response";
import wretch from "wretch";

export default ({ state, dispatch, commit }, { response, meeting }) => {
  dispatch;
  wretch("/api/set-rsvp")
    .auth(state.email)
    .formData({
      response,
      meetingID: meeting.id,
      memberID: state.member.id
    })
    .post()
    .json()
    .then(handleResponse)
    .then(() => {
      dispatch("getNextMeeting");
      commit("setSnack", {
        visible: true,
        color: "success",
        text: "RSVP Updated"
      });
    })
    .catch(text => {
      commit("setSnack", {
        visible: true,
        color: "error",
        text
      });
    });
};
